import { apiGetRequest, apiPostRequest } from 'utilities/http/api/apiHttp';
import { NoteMessage } from 'types';

export const apiNote = {
  getNotes: (travelPackageId: number) =>
    apiGetRequest<{ notes: NoteMessage[] }>(`travel/${travelPackageId}/note`),

  postNote: (travelPackageId: number, message: string) => {
    const notePayload = {
      note: {
        message,
        noteTypeId: 11,
      },
    };
    return apiPostRequest<{ note: NoteMessage }>(
      `travel/${travelPackageId}/note`,
      notePayload,
    );
  },
};
